import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, BellSimple } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Layout>
      <PageHeader title="Notifications" subtitle="Migration completion & failure alerts"
        actions={<Button data-testid="read-all-btn" variant="outline" size="sm" onClick={readAll} className="rounded-xl">Mark all read</Button>} />
      <div className="p-8 max-w-3xl space-y-3">
        {items.length === 0 && (
          <div className="bg-white border border-dashed border-stone-300 rounded-xl py-16 text-center">
            <BellSimple size={36} className="mx-auto text-stone-300" />
            <p className="text-stone-500 mt-3 text-sm">No notifications yet.</p>
          </div>
        )}
        {items.map((n) => (
          <Link to={n.job_id ? `/jobs/${n.job_id}` : "#"} key={n.id} data-testid={`notif-${n.id}`}
            className={`flex items-start gap-3 bg-white border rounded-xl p-4 hover:border-[#C2410C] transition-colors duration-200 ${n.read ? "border-stone-200" : "border-[#C2410C] bg-orange-50/40"}`}>
            {n.type === "success" ? <CheckCircle size={20} weight="fill" className="text-emerald-600 shrink-0" />
              : <XCircle size={20} weight="fill" className="text-rose-600 shrink-0" />}
            <div className="flex-1">
              <div className="font-medium text-sm text-stone-900">{n.title}</div>
              <div className="text-xs text-stone-500 mt-0.5">{n.message}</div>
            </div>
            <div className="text-xs text-stone-400">{n.created_at ? new Date(n.created_at).toLocaleString() : ""}</div>
          </Link>
        ))}
      </div>
    </Layout>
  );
}
